<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="money-bill"
    :header_text_short="$t('WorkpackageRework.Info.Costs.Header').toUpperCase()"
    :header_text_long="$t('WorkpackageRework.Info.Costs.Header').toUpperCase()"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
  >
    <template #body>
      <div
        v-if="backlog || getOwnTWorkPackages(project_id).length === 0 || getOwnTWorkPackages(project_id).includes(workpackage.id) "
        class="work-package-costs-container"
        >
        <!-- STRATEGY -->
        <div class="work-package-costs-strategy">
          <DropDownOutlinedFlat
            :label="'Cost strategy'"
            :options="cost_strategies"
            :is_disabled="!isEditMode"
            :value="getCostStrategy(workpackage.cost_strategy)"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @change="changeValue('cost_strategy', fixCostStrategie({id: $event}))"
          />
          <LabelOutlined
            :label="'Strategy description'"
            :is_disabled="true"
            :height="42.5"
            :dark="is_light_mode(workpackage_fg_hex)"
            :background_color="workpackage_bg_hex"
          >
            <template #content>
              <TText
                :text="getCostStrategy(workpackage.cost_strategy).description"
                :size="10"
                :color="workpackage_fg_hex"
              />
            </template>
          </LabelOutlined>
        </div>
        <!-- TOTAL COST -->
        <div v-if="show_total" class="work-package-costs-total">
          <div v-if="show('Budget')" class="work-package-costs-equation">
            <ModularEquation
              :elements="getEquation({
                project_id,
                workpackage_id,
                prefix: prefix,
                type: 'total',
                structure: [{tag:'budget_total', optional: {}}],
                })"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @changeTotalBudget="changeValue('costs_budget_total', parseFloat($event))"
            />
          </div>
          <div v-if="show('Tendered')" class="work-package-costs-equation">
            <ModularEquation
              :description="`${/*'Tendered'*/''}`"
              :elements="getEquation({
                project_id,
                workpackage_id,
                prefix: prefix,
                type: 'total',
                structure: show('Budget') ? [{tag:'tendered_total', optional: {}},{tag:'divides', optional: {}} ,{tag:'budget_total', optional: {is_disabled:true}} ]:[{tag:'tendered_total', optional: {}}]
                })"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @changeTenderedCosts="changeValue('costs_tendered_total', parseFloat($event))"
            />
          </div>
          <div v-if="show('Paid out')" class="work-package-costs-equation">
            <ModularEquation
              :description="`${/*'Paid Out'*/''}`"
              :elements="getEquation({
                project_id,
                workpackage_id,
                prefix: prefix,
                type: 'total',
                structure: [{tag:'paid_out_total', optional: {}},{tag:'divides', optional: {}} ,{tag:'tendered_total', optional: {is_disabled:true}} ]
                })"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @changePaidOut="changeValue('costs_paid_out_total', parseFloat($event))"
            />
          </div>
        </div>
        <!-- 3x3 MATRIX -->
        <div v-if="show('Budget')" class="work-package-costs-equation">
          <ModularEquation
            :description="$t('WorkpackageRework.Info.Costs.Budget')"
            :elements="getEquation({
              project_id,
              workpackage_id,
              prefix: prefix,
              type: 'budget',
              structure: getCostStrategy(workpackage.cost_strategy).elements
              })"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @changeMaterial="changeValue('costs_budget_material', parseFloat($event))"
            @changeLabour="changeValue('costs_budget_labour', parseFloat($event))"
          />
        </div>
        <div v-if="show('Tendered')" class="work-package-costs-equation" :key="workpackage.cost_strategy.id">
          <ModularEquation
            :description="$t('WorkpackageRework.Info.Costs.Tendered')"
            :elements="getEquation({
              project_id,
              workpackage_id,
              prefix: prefix,
              type: 'tendered',
              structure: getCostStrategy(workpackage.cost_strategy).elements
              })"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @changeMaterial="changeValue('costs_tendered_material', parseFloat($event))"
            @changeLabour="changeValue('costs_tendered_labour', parseFloat($event))"
          />
        </div>
        <div v-if="show('Paid out')" class="work-package-costs-equation">
          <ModularEquation
            :description="$t('WorkpackageRework.Info.Costs.PaidOut')"
            :elements="getEquation({
              project_id,
              workpackage_id,
              prefix: prefix,
              type: 'paid_out',
              structure: getCostStrategy(workpackage.cost_strategy).elements
              })"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @changeMaterial="changeValue('costs_paid_out_material', parseFloat($event))"
            @changeLabour="changeValue('costs_paid_out_labour', parseFloat($event))"
          />
        </div>
      </div>
      <div v-else>
        <TText
          value="You do not have permissions to access the costs of this WORK.package"
          align="center"
          small
          :color="workpackage_fg_hex"
        />
      </div>
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
// import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import ModularEquation from '@/modules/WorkPackageWIP/ModularEquation.module.vue';
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';

  export default {
    components: {
      WorkPackageSubPageModule,
      // SubpageHeader,
      ModularEquation,
      LabelOutlined,
      DropDownOutlinedFlat,
      TText,
    },
    mixins: [
      WorkPackageReworkMixin
    ],
    props: ['location', 'backlog', 'prefix'],

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',
      show_total: true,
      is_edit: true,
      strategy_index: 4,
    }),
    created() {
      this.loadData();
    },
    watch: {
      // workpackage_id() {
      //   this.loadData();
      // },
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
      ...mapGetters('TWorkPackage', [
        'getCostStrategy',
        'getEquation'
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
        'hasProjectPermission'
      ]),
      ...mapState('TWorkPackage', [
        'cost_strategies'
      ]),
    },
    methods: {
      show(type) {
        return this.hasProjectPermission({project_id: this.project_id, ppermission: 'Read Work Package ' + type + ' Costs'}) ||
          (this.hasProjectPermission({project_id: this.project_id, ppermission: 'Read Own Work Package ' + type + ' Costs'}) &&
          this.getOwnTWorkPackages(this.project_id).includes(this.workpackage_id));
      },
      fixCostStrategie(value) {
         return Object.assign(value, {
          description: this.getCostStrategy(value).description,
          name: this.getCostStrategy(value).text,
        })
      },
      changeValue(target, value) {
        if (this.backlog) {
          this.updateUObject({
            url: this.workpackage_url,
            update: {
              [target]: value
            },
          })
        } else {
          this.requestSnackbarUpdate({
            url: this.workpackage_url,
            update: {
              [target]: value
            },
            selector: "target"
          }).then((payload) => {
            this.updateUObject(payload);
          });
        }
        console.log(this.workpackage);
      },
      loadData() {

      },
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbar',
        'requestSnackbarCreate',
        'requestSnackbarUpdate',
        'requestSnackbarUpdatePosition',
        'requestSnackbarDelete',
        'updateSnackbar'
      ]),
    },
  }
</script>
<style media="screen">
.work-package-costs-container {
  width: 100%;
}
.work-package-costs-total {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.work-package-costs-strategy {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.work-package-costs-equation {
  display: flex;
  align-items: center;
}
</style>
